/* global BigInt */
import { PayloadType } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';

export default (messages) => {
  const usersIds = new Set();
  const groupsIds = new Set();

  messages.forEach((message) => {
    if (message.senderId) {
      usersIds.add(message.senderId);
    }

    if (message.repliedMessage && message.repliedMessage.senderId) {
      usersIds.add(message.repliedMessage.senderId);
    }

    if (message.payload?.initiator) {
      usersIds.add(message.payload?.initiator);
    }

    if (message.quote) {
      const { source } = message.quote;
      const userId = source.user?.userId || source.userChat?.user.userId || source.unknown?.userId;
      const groupId = source.chat?.chatId || source.userChat?.chat.chatId || source.unknown?.chatId;

      if (userId) {
        usersIds.add(userId);
      }
      if (groupId) {
        groupsIds.add(groupId);
      }
    }

    if (message.payload?.users) {
      message.payload.users.forEach((user) => usersIds.add(user.id));
    }

    const userMentions = message.payload.userMentions;

    if (userMentions && userMentions.length) {
      userMentions.forEach((mention) => {
        // ignore @all mentionId
        if (BigInt(mention.userId) > 0) {
          usersIds.add(mention.userId);
        }
      });
    }

    const group = Entities.GroupsStore.getGroupById(message.groupId);

    // load forward data to the saved messages group
    if (group?.isSavedMessages && message.forwardedMessage) {
      if (message.forwardedMessage.senderId) {
        usersIds.add(message.forwardedMessage.senderId);
      }

      if (message.forwardedMessage.groupId) {
        groupsIds.add(message.forwardedMessage.groupId);
      }
    }

    if (message.payload.payloadType === PayloadType.Contact) {
      usersIds.add(message.payload.userId);
    }

    // articles and albums
    if (message.payload.payloads) {
      message.payload.payloads.forEach((parentPayload) => {
        if (parentPayload.payload.payloadType === PayloadType.Contact) {
          usersIds.add(parentPayload.payload.userId);
        }

        const userMentions = parentPayload.payload.userMentions;

        if (userMentions && userMentions.length) {
          userMentions.forEach((mention) => {
            if (BigInt(mention.userId) > 0) {
              usersIds.add(mention.userId);
            }
          });
        }
      });
    }
  });

  return {
    usersIds: Array.from(usersIds.values()),
    groupsIds: Array.from(groupsIds.values()),
  };
};
